(function ($) {
  Drupal.behaviors.collectionPopUp = {
    attach: function (context) {
      $('.collection_hero_popup__container', context).hide();

      $('#collection_popup_cta').live('click', function (event) {
        $('.collection_hero_popup__container').fadeIn();
      });

      $('#collection_popup_close').live('click', function (event) {
        $('.collection_hero_popup__container').fadeOut();
      });
    }
  };
})(jQuery);
